import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Input } from "@mui/material";
import { NumericFormat } from "react-number-format";
import { t } from "i18next";

import { Icon } from "components";
import { getButtonBgColor, getFontFamily } from "slices";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({ target: { name: props.name, value: values.value } });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
    />
  );
});

const PriceInputOptionTile = ({ placeholder = "", disabled, onClick, componentOptions }) => {
  const color = useSelector(getButtonBgColor);
  const fontFamily = useSelector(getFontFamily);
  const [value, setValue] = useState("");

  const onChange = (e) => {
    let v = e.target.value;
    const pattern = /^\d*$/;

    if (e.target.value.startsWith(componentOptions.prefix)) {
      v = e.target.value.slice(1);
    }

    if (pattern.test(v)) {
      setValue(v);
    }
  };

  const onSendClick = () => {
    const callbackOptions = {
      ...componentOptions.callbackOptions,
      data: { ...componentOptions.callbackOptions.data, data: `${componentOptions.prefix || ""}${value}` },
    };

    onClick([{ message: `${componentOptions.prefix || ""}${value}`, speaker: "user" }], callbackOptions);
  };

  return (
    <div className="hayley-relative hayley-mb-3 hayley-mr-3 hayley-flex hayley-h-full hayley-max-h-[42px] hayley-w-fit hayley-items-center hayley-border hayley-border-solid hayley-border-custom-4">
      <Input
        className={`hayley-max-h-inherit hayley-w-fit hayley-border-none hayley-bg-transparent hayley-py-[10px] hayley-pl-4 hayley-pr-4 hayley-font-opensans hayley-text-sm hayley-text-secondary placeholder:hayley-text-gray-400 focus:hayley-outline-none ${
          value === "" ? "hayley-font-medium" : "hayley-font-semibold"
        }`}
        style={{ fontFamily }}
        value={value}
        placeholder={t(placeholder)}
        onChange={onChange}
        inputComponent={NumericFormatCustom}
        disableUnderline
      />
      <Button
        className={`hayley-custom hayley-absolute hayley-right-0 hayley-h-full hayley-min-w-min hayley-cursor-pointer hayley-items-center hayley-justify-center hayley-rounded-none hayley-border-0 hayley-border-l hayley-border-solid hayley-border-custom-4 hayley-bg-transparent hayley-p-2 hayley-text-secondary disabled:hayley-cursor-not-allowed ${
          value === "" ? "hayley-hidden" : "hayley-flex"
        }`}
        sx={{ "&.hayley-custom": { "&:hover": { color: `${color} !important` } } }}
        disabled={disabled || value === ""}
        onClick={onSendClick}
      >
        <Icon iconType="Send2" className="hayley-h-6 hayley-w-6 hayley-text-inherit" />
      </Button>
    </div>
  );
};

export default PriceInputOptionTile;
